<template>
	<div :class="classes">
		<div class="one-on-one-list-placeholder__icons">
			<FontAwesomeIcon
				class="one-on-one-list-placeholder__icon"
				:icon="[ `fac`, `one-on-one` ]"
			/>
		</div>
		<h1 class="one-on-one-list-placeholder__heading">
			{{ $t( "common.OneOnOneListPlaceholder_title" ) }}
		</h1>
		<h2 class="one-on-one-list-placeholder__subheading">
			{{ $t( "common.OneOnOneListPlaceholder_subtitle" ) }}
		</h2>
		<div class="one-on-one-list-placeholder__buttons">
			<TeamingButton
				@click="$emit( `create` )"
			>
				{{ $t( "common.OneOnOneListPlaceholder_createButton" ) }}
			</TeamingButton>
		</div>
	</div>
</template>

<script>
import TeamingButton from "../buttons/TeamingButton.vue";

export default {
	name: "OneOnOneListPlaceholder",
	components: {
		TeamingButton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"one-on-one-list-placeholder": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.one-on-one-list-placeholder {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.one-on-one-list-placeholder__icons {
	margin: 1.6rem 0;
}

.one-on-one-list-placeholder__icon {
	// TODO: replace with ACTUAL duotone selectors once supported for custom icons
	color: $one-on-one-list-placeholder-icon-color;
	background-color: $one-on-one-list-placeholder-icon-background-color;
	@include font-and-line-for(7);
	border-radius: 0.5rem;
}

.one-on-one-list-placeholder__heading {
	@include font-and-line-for(1);
	color: $one-on-one-list-placeholder-heading-color;
	font-weight: 600;
}

.one-on-one-list-placeholder__subheading {
	margin: 1rem 0;
	@include font-and-line-for(0);
	color: $one-on-one-list-placeholder-subheading-color;
	font-weight: 400;
}
</style>
